var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Collapse Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "entire_collapse_icon-b",
    d: "M22,45 C9.80478499,44.7289498 0,34.75949 0,22.5 C0,10.24051 9.80478499,0.271050237 22.0005417,0.0054340303 L22,0 L60,0 L60,45 L22,45 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "entire_collapse_icon-a",
    width: "123.3%",
    height: "131.1%",
    x: "-11.7%",
    y: "-11.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#entire_collapse_icon-a)",
    xlinkHref: "#entire_collapse_icon-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#222E49",
    xlinkHref: "#entire_collapse_icon-b"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "matrix(1 0 0 -1 20 33)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.45,
    x2: 8.976,
    y1: 1.425,
    y2: 9.951
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.45,
    x2: 8.976,
    y1: 10.425,
    y2: 18.951,
    transform: "matrix(1 0 0 -1 0 28.95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCollapse);
export default __webpack_public_path__ + "static/media/settings_collapse.dd21b9b4ac92b1fd2e7f1df61f09d53e.svg";
export { ForwardRef as ReactComponent };